import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';

interface props {
    children: React.ReactNode
}

const DefaultLayout = ({ children }: props): JSX.Element => {
    return (
        <Fragment>
            <Helmet>
                <link rel="icon" type="image/x-icon" href="/favicon.png" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
                <link href="https://fonts.googleapis.com/css2?family=Cousine&family=Poppins:wght@400;600;700&display=swap" rel="stylesheet" />
            </Helmet>
            <Header />
            {children}
            <Footer />
        </Fragment>
    );
};

export default DefaultLayout;
